module.exports = __webpack_public_path__ + "sq22-b11ecb6b.png";